import lazyLoading from "./lazyLoading";

export default {
  name: "worklist",
  path: "/worklist",
  component: lazyLoading("worklist/Worklist"),
  meta: {
    default: false,
    title: "Radni list",
    class: "primary",
    show: false,
    iconClass: "fa fa-file-pdf-o",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/worklist.js